const FB_PIXEL_ID = '1381672243816471'
const FB_EVENTS_SRC = 'https://connect.facebook.net/en_US/fbevents.js'
const shouldSendFbPixel = process.env.NODE_ENV === 'production'
const shouldLogFbPixel = !shouldSendFbPixel

function ensureFbqStub () {
  if (typeof window === 'undefined') return
  if (typeof window.fbq === 'function') return

  const n = function (...args) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args)
  }
  n.queue = []
  n.loaded = false
  n.version = '2.0'
  n.push = n
  window.fbq = n
  if (!window._fbq) window._fbq = n
}

/** index.html 里的 sdk.js 可能先定义 fbq，导致旧逻辑跳过 fbevents.js 加载 */
function ensureFbeventsScript () {
  if (typeof document === 'undefined') return
  if (document.querySelector(`script[src="${FB_EVENTS_SRC}"]`)) return

  const script = document.createElement('script')
  script.async = true
  script.src = FB_EVENTS_SRC
  const firstScript = document.getElementsByTagName('script')[0]
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    document.head.appendChild(script)
  }
}

function initMetaPixel () {
  if (!shouldSendFbPixel) return
  ensureFbqStub()
  ensureFbeventsScript()
  window.fbq('init', FB_PIXEL_ID)
}

initMetaPixel()

function logFbPixelEvent (method, eventName, params = {}) {
  logger.info('[Meta Pixel]', method, eventName, params)
}

function sendFbPixelEvent (method, eventName, params = {}) {
  logFbPixelEvent(method, eventName, params)

  if (typeof window.fbq !== 'function') {
    logger.warn('[Meta Pixel]', `${method} failed (fbq not loaded)`, eventName, params)
    return
  }

  if (method === 'trackCustom') {
    window.fbq('trackCustom', eventName, params)
    return
  }

  window.fbq('track', eventName, params)
}

/**
 * Meta Pixel 标准事件
 * @param {string} eventName
 * @param {object} [params]
 */
export function trackFbEvent (eventName, params = {}) {
  if (shouldSendFbPixel) {
    sendFbPixelEvent('track', eventName, params)
    return
  }

  logFbPixelEvent('track (dry-run)', eventName, params)
}

/**
 * Meta Pixel 自定义事件
 * @param {string} eventName
 * @param {object} [params]
 */
export function trackFbCustomEvent (eventName, params = {}) {
  if (shouldSendFbPixel) {
    sendFbPixelEvent('trackCustom', eventName, params)
    return
  }

  logFbPixelEvent('trackCustom (dry-run)', eventName, params)
}

if (typeof window !== 'undefined') {
  window.trackFbEvent = trackFbEvent
  window.trackFbCustomEvent = trackFbCustomEvent
}
